import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// material-ui icons
import { Add, Filter9Plus } from "@mui/icons-material";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import Button from "../../components/CustomButtons/Button";

import tagsStyle from "../../assets/jss/material-dashboard-pro-react/views/tagsStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import * as actions from "../../store/actions";

//Modals
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import TextFilter from "../../components/Filters/TextFilter";

class Index extends React.Component {
  state = {
    selectedIds: [],
    showDeleteAlert: false,
  };

  toggleModal(modal) {
    let newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  hideDeleteAlert = () => {
    this.setState({ showDeleteAlert: false });
  };

  canCreateNieuwItem = () => {
    if (this.props.vestiging_id) {
      return true;
    }
    return false;
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Tags overview"} tKey={"tags.pagetitle"} />} />
        <GridContainer>
          {this.canCreateNieuwItem() ? (
            <GridItem xs={12}>
              <Link to={"./create"}>
                <Button className={classes.marginRight} color={"success"}>
                  <Add className={classes.icons} /> <TranslationWrapper tDefault={"New tag"} tKey={"tags.nieuw.item"} />
                </Button>
              </Link>
            </GridItem>
          ) : null}
        </GridContainer>
        <GridContainer>
          <VestigingenFilter />
          <GridItem md={4} xs={12}>
            <TextFilter
              field={"tagName"}
              fieldKey={"tags:tagName"}
              operator={"like"}
              placeholder={getTranslation("tags.filter.tagName", "Filter one tag name")}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "vestiging.naam", editable: false },
                { dbfield: "active", editable: false },
                { dbfield: "tagType", editable: false },
                { dbfield: "tagName", editable: false },
              ]}
              dbfields={"id,tagType,active,tagName,vestiging_id,vestiging.id,vestiging.naam"}
              delete={"tags.delete"}
              editLink={"./:id/edit"}
              editLinkPermission={"tags/:id/edit"}
              fetchUrl={"core/tags"}
              filters={this.props.filters}
              headerIcon={<Filter9Plus />}
              headers={[
                {
                  label: getTranslation("tags.tag.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("tags.tag.vestiging", "Salesarea"),
                  sortable: false,
                  width: "20%",
                  sortKey: "vestiging.naam",
                },
                {
                  label: getTranslation("tags.tag.active", "Active"),
                  sortable: false,
                  width: "20%",
                  sortKey: "active",
                },
                {
                  label: getTranslation("tags.tag.tagType", "Tag type"),
                  sortable: false,
                  width: "20%",
                  sortKey: "tagType",
                },
                {
                  label: getTranslation("tags.tag.tagName", "Naam"),
                  width: "20%",
                  sortable: false,
                  sortKey: "naam",
                },
              ]}
              multieSelect
              multieSelectHandler={this.handleMultieSelect}
              reduxKey={"tags"}
              tableTitle={<TranslationWrapper tDefault={"Tags"} tKey={"tags.tag.titel"} />}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  let filters = getVestigingFilterState(state);
  if (state.filtersV2["tags:tagName"]) {
    filters["tags:tagName"] = state.filtersV2["tags:tagName"];
  }
  return {
    user_id: state.user.id,
    vestiging_id: state.filtersV2.vestiging_id?.value,
    filters: filters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Index, tagsStyle));
